
import DetailsVerticalListTrigger from './DetailsVerticalListTrigger';
import classes from './PatientDetailsComponent.module.css'

import PatientDetailsInner from "./PatientDetailsInner";

const PatientDetailsComponent = ({noWorkQ}) => {
    return <div className={classes.container}>
        {!noWorkQ && <DetailsVerticalListTrigger />}
        <PatientDetailsInner />
    </div>
}

export default PatientDetailsComponent